import { Element } from 'react-bulma-components';
import Button from '../../ui/button/button';
import Modal from '../../ui/modal/modal';

export type TemporaryAccessSetupCompletedConfirmationModalProps = {
  show: boolean;
  email: string;
  navigateToTemporaryAccessDashboardPage: () => void;
  loading: boolean;
};

const TITLE = 'Access granted';
const SUBTITLE = (email: string) =>
  `You have successfully granted temporary permissions to ${email}`;
const BUTTON_TEXT = 'Done';

export function TemporaryAccessSetupCompletedConfirmationModal({
  show,
  email,
  navigateToTemporaryAccessDashboardPage,
  loading,
}: TemporaryAccessSetupCompletedConfirmationModalProps) {
  return (
    <Modal show={show} title={TITLE} titleClassName="mb-4">
      <p className="is-size-7">{SUBTITLE(email)}</p>
      <Element
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        mt={8}
      >
        <Button
          color="primary-dark"
          onClick={navigateToTemporaryAccessDashboardPage}
          isExecutingAction={loading}
        >
          {BUTTON_TEXT}
        </Button>
      </Element>
    </Modal>
  );
}

export default TemporaryAccessSetupCompletedConfirmationModal;
